/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IPlpSubheaderViewProps } from './plp-subheader';

export default (props: IPlpSubheaderViewProps) => {
    const { config } = props;
    const { title, subtitle, backgroundImage } = config;

    if (!title && !backgroundImage?.src) {
        return null;
    }

    const backgroundStyle: React.CSSProperties = {};
    if (backgroundImage?.src) {
        backgroundStyle.backgroundImage = `url('${backgroundImage.src}')`;
    }

    return (
        <div className='plp-subheader'>
            <div className='plp-subheader__background' style={backgroundStyle}>
                <div className='container'>
                    <div className='plp-subheader__content'>
                        <h1 className='plp-subheader__title'>{title}</h1>
                        <p className='plp-subheader__subtitle'>{subtitle}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
